import {
  Route,
  BrowserRouter as Router,
  Routes,
  useNavigate
} from 'react-router-dom';

import { AccessError } from '../shared/components/AccessError';
import ApolloClientService from '../shared/services/ApolloClientService';
import { ApolloProvider } from '@apollo/client';
import { AssessmentLessonList } from './components/AssessmentLessonList';
import Config from '../shared/config';
import FeatureAccessService from '../shared/services/FeatureAccessService';
import { LessonPlayerMarkerView } from './components/LessonPlayerMarkerView';
import { Page404 } from '../shared/components/Page404';
import React from 'react';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { TitleWrapper } from '../shared/components/TitleWrapper';
import User from '../membership/models/User';

interface AssessmentProps {
  user: User;
}

function App(props: AssessmentProps) {
  const navigate = useNavigate();

  const apolloClient = ApolloClientService.create(Config.ASSESSMENT_GQL);
  const [tabIndex, setTabIndex] = React.useState(0);

  function handleCloseLessonPlayer() {
    navigate('/assessments');
  }

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setTabIndex(newValue);
  };

  return FeatureAccessService.hasMarkerAccess ? (
    <>
      <Tabs value={tabIndex} onChange={handleChange}>
        <Tab label="Open Assessments" />
        <Tab label="Finalised Assessments" />
      </Tabs>
      <Routes>
        <Route
          index
          key="list"
          element={
            <ApolloProvider client={apolloClient}>
              <TitleWrapper
                title="Assessments"
                style={{ height: 'calc(100% - 50px)' }}
              >
                <AssessmentLessonList {...props} isFinalised={tabIndex === 1} />
              </TitleWrapper>
            </ApolloProvider>
          }
        />
        <Route
          key="view"
          path="/view"
          element={<LessonPlayerMarkerView onClose={handleCloseLessonPlayer} />}
        />
        {/* Fallback route for 404 page */}
        <Route path="*" element={<Page404 />} />
      </Routes>
    </>
  ) : (
    <AccessError />
  );
}

export default App;
